import {View} from './view';

declare const fbq: any;

export class FacebookPixelView extends View {

    private facebookPixelId = '';

    render(facebookPixelId: string) {
        this.facebookPixelId = facebookPixelId;
        this.appendFacebookPixelScript();
        this.appendFacebookPixelNoScript();
    }

    appendFacebookPixelScript() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = this.getFacebookPixelCode();
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    getFacebookPixelCode = () => {
        return `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');

            fbq('init', '${this.facebookPixelId}');
            fbq('track', 'PageView');
        `;
    }

    appendFacebookPixelNoScript() {
        const noscript = document.createElement('noscript');
        noscript.innerHTML = this.getFacebookPixelNoScript();
        document.getElementsByTagName('head')[0].appendChild(noscript);
    }

    getFacebookPixelNoScript = () => {
        return `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${this.facebookPixelId}&ev=PageView&noscript=1"/>`;
    }

    getFbqInstance = () => {
        return fbq;
    }

}
